import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UtilService } from 'src/app/shared/services/util.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { InscripcionPlanCompensacion } from 'src/app/models/inscripcionPlanCompensacion.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { PlanCompensatorioModel } from 'src/app/models/planCompensatorio.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Component({
    selector: 'app-lista-compensacion-dependencia',
    templateUrl: './lista-compensacion-dependencia.component.html',
    styleUrls: ['./lista-compensacion-dependencia.component.scss']
})
export class ListaCompensacionDependenciaComponent implements OnInit {

    tipoDocumento: string;
    numeroDocumento: string;

    filtro: string;
    inscripcionSeleccionada: InscripcionPlanCompensacion;
    listaInscripciones: InscripcionPlanCompensacion[];
    listaInscripcionesFiltro: InscripcionPlanCompensacion[];

    plan: PlanCompensatorioModel;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        this.tipoDocumento = sessionStorage.getItem('tipoDocumento');
        this.numeroDocumento = sessionStorage.getItem('numDocumento');
        this.consultarPlanCompensacionActual();
        this.consultarInscripciones();
    }

    /**
     * Método que permite filtar las inscripciones mostradas al usuario
     * @function filtrarInscripciones
     * @author dfranco@asesoftware.com
     */
    public filtrarInscripciones() {
        if (this.filtro && this.filtro.trim() !== '') {
            this.listaInscripcionesFiltro = this.listaInscripciones.filter(
                item => {
                    const filtroTemp = this.filtro.toUpperCase();
                    const documento = item.numeroIdFuncionario;
                    const nombre = item.nombreCompleto.toUpperCase();
                    return documento.indexOf(filtroTemp) !== -1 || nombre.indexOf(filtroTemp) !== -1;
                }
            );
        } else {
            this.listaInscripcionesFiltro = this.listaInscripciones;
        }
    }

    /**
     * Método que muestra el detalle de una inscripción
     * @function verDetalle
     * @author dfranco@asesoftware.com
     * @param  inscripcion Inscripción seleccionada en la tabla
     */
    public verDetalle(inscripcion: InscripcionPlanCompensacion) {
        this.inscripcionSeleccionada = inscripcion;
    }

    /**
     * Método que permite recargar el contenido de la página
     * @author dfranco@aseosftware.com
     * @function recargarPagina
     */
    recargarPagina() {
        this.inscripcionSeleccionada = undefined;
        this.consultarPlanCompensacionActual();
        this.consultarInscripciones();
    }

    /**
     * Método que permite consultar el listado de inscripciones de las personas asociadas a la dependencia donde el funcionario es jefe
     * @function consultarInscripciones
     * @author dfranco@asesoftware.com
     */
    public consultarInscripciones() {
        this.spinner.show();
        const serviceProvider = 'getInscripcionesPorDependencia';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.tipoDocumento]);
        queryParams.push(['numeroDocumento', this.numeroDocumento]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data && data.length > 0) {
                    this.listaInscripciones = data;
                    this.listaInscripcionesFiltro = data;
                } else {
                    this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTEN_SOLICITUDES_APROBAR, '');
                }
                this.spinner.hide();
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método que permite consultar el plan de compensación activo o actual
     * @function consultarPlanCompensacionActual
     * @author dfranco@asesoftware.com
     */
    public consultarPlanCompensacionActual() {
        this.spinner.show();
        const serviceProvider = 'consultarCompensacion';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=estado', DominiosService.ESTADO_PLAN_COMPENSACION_ACTIVO]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.getGenerico(url).subscribe(
            data => {
                if (data.length > 0) {
                    const fechaActual: Date = new Date();
                    this.plan = data[0];
                    if (this.utilService.setearFinFecha((new Date(this.plan.fechaInicialAutorizacion))).getTime() 
                            > this.utilService.setearFinFecha(fechaActual).getTime() ||
                        this.utilService.setearFinFecha((new Date(this.plan.fechaFinalAutorizacion))).getTime() 
                            < this.utilService.setearFinFecha(fechaActual).getTime()) {
                        this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTEN_SOLICITUDES_APROBAR, '');
                    }
                } else {
                    this.alertService.generateAlertError(ConstantesService.MENSAJE_NO_EXISTE_PLAN_COMPENSACION, '');
                }
            }, err => {
                if (err.status === '500') {
                    this.catchException(err.error.message);
                } else {
                    this.catchException('Error al consultar plan de compensación actual');
                }
            }
        );
    }

    /**
     * Método de control de Excepciones
     * @function cathException
     * @author dfranco@asesoftware.com
     * @param  error  mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.utilService.cathException(error, this.alertService, this.spinner);
    }
}